// @ts-nocheck
import API from "../API/API";

const buildLoginRedirectPath = () => {
  if (typeof window === "undefined") {
    return "/login";
  }

  const currentPath = `${window.location.pathname || "/"}` +
    `${window.location.search || ""}` +
    `${window.location.hash || ""}`;

  return `/login?redirect=${encodeURIComponent(currentPath)}`;
};

const redirectToLogin = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem("persist:root");
  window.sessionStorage.setItem("premiumblog:session-expired", "1");
  window.location.assign(buildLoginRedirectPath());
};

const refreshAuthSession = async () => {
  const response = await fetch(`${API.BASE_URL}/auth/refresh`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.ok;
};

export const authFetch = async (url, options = {}) => {
  const {
    redirectOnUnauthorized = false,
    _skipRefresh = false,
    ...fetchOptions
  } = options;

  const response = await fetch(url, {
    credentials: "include",
    ...fetchOptions,
    headers: {
      ...(fetchOptions.headers || {}),
    },
  });

  const isRefreshRequest = String(url).includes("/auth/refresh");

  if (response.status === 401 && !_skipRefresh && !isRefreshRequest) {
    try {
      const refreshed = await refreshAuthSession();

      if (refreshed) {
        return authFetch(url, {
          ...fetchOptions,
          redirectOnUnauthorized,
          _skipRefresh: true,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  if (redirectOnUnauthorized && response.status === 401) {
    redirectToLogin();
    throw new Error("SESSION_EXPIRED");
  }

  return response;
};
